import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './HeroSection.css';
import grandmaNieceImage from '../../../assets/photos/grandma niece.jpg';
import qrImage from '../../../assets/qr.jpg';
import { formatPrice } from '../../../utils/currency';
import { hasValidAuthentication } from '../../../services/auth';

const HeroSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'mk';
  const [loggedInUser, setLoggedInUser] = useState(() => {
    const fullName = localStorage.getItem('userFullName');
    return hasValidAuthentication() ? (fullName || t('memberWelcome.userFallback', 'User')) : '';
  });

  useEffect(() => {
    const syncLoggedInUser = () => {
      const fullName = localStorage.getItem('userFullName');
      setLoggedInUser(hasValidAuthentication() ? (fullName || t('memberWelcome.userFallback', 'User')) : '');
    };

    syncLoggedInUser();
    window.addEventListener('storage', syncLoggedInUser);
    window.addEventListener('authChange', syncLoggedInUser);

    return () => {
      window.removeEventListener('storage', syncLoggedInUser);
      window.removeEventListener('authChange', syncLoggedInUser);
    };
  }, [t]);

  const isLoggedIn = Boolean(loggedInUser);

  return (
    <section className="hero-section">
      {/* Background with warm overlay */}
      <div className="hero-background">
        <div className="hero-image-container">
          <img 
            src={grandmaNieceImage} 
            alt="Grandmother and family memories"
            className="hero-background-image"
          />
          <div className="hero-overlay"></div>
        </div>
      </div>

      <div className="hero-container">
        {/* Mobile Title */}
        <div className="mobile-title">
          <h1 className="mobile-title-text">Спомен МК</h1>
        </div>
        
        <div className="hero-content">
          {/* Left side - Main content */}
          <div className="hero-main">
            <h1 className="hero-title">
              {t('hero.title', 'Нивната Приказна.')}
              <span className="hero-title-accent"> {t('hero.titleAccent', 'Зачувана Засекогаш.')}</span>
            </h1>
            
            <p className="hero-description">
              {t('hero.description', 'Повеќе од име на камен. Создадете прекрасен дигитален споменар за вашите најблиски и поврзете го со нивното вечно почивалиште преку елегантна QR плочка.')}
            </p>
            
            {!isLoggedIn && (
              <div className="hero-actions">
                <Link to={`/${currentLang}/register`} className="btn-primary">
                  {t('hero.createButton', 'Создади Бесплатен Профил')}
                </Link>
                <Link to={`/${currentLang}/products`} className="btn-secondary">
                  {t('hero.orderPlate', 'Нарачајте QR паметна плочка за споменик')}
                </Link>
              </div>
            )}
          </div>

          {/* Right side - Product showcase */}
          <div className="hero-product-showcase">
            <div className="product-card">
              <div className="product-card-header">
                <div className="qr-code-visual">
                  <img src={qrImage} alt="QR Code" className="qr-image" />
                </div>
              </div>
              
              <div className="product-card-content">
                <h3 className="product-title">
                  {t('hero.product.title', 'Smart QR плочка за спомен')}
                </h3>
                
                <div className="product-price">
                  <span className="price-current">{formatPrice(1990, currentLang)}</span>
                </div>
                <ul className="product-features">
                  <li>
                    <span className="feature-text"><span className="inline-feature-bullet">•</span>&nbsp;&nbsp;{t('hero.product.feature2', 'Висококвалитетен материјал Inox 304 отпорен на сите временски услови.')}</span>
                  </li>
                  <li>
                    <span className="feature-text"><span className="inline-feature-bullet">•</span>&nbsp;&nbsp;{t('hero.product.oneTimePayment', 'Еднократно плаќање, доживотна употреба')}</span>
                  </li>
                  <li>
                    <span className="feature-text"><span className="inline-feature-bullet">•</span>&nbsp;&nbsp;{t('hero.product.feature3', 'Неограничени промени')}</span>
                  </li>
                  <li>
                    <span className="feature-text"><span className="inline-feature-bullet">•</span>&nbsp;&nbsp;{t('hero.product.feature1', 'Повеќејазичен профил')}</span>
                  </li>
                </ul>
                
                <div className="additional-services">
                  <p className="shipping-info">
                    <span className="service-icon">🚚</span>
                    {t('hero.product.freeShipping', 'Бесплатна достава низ цела Македонија')}
                  </p>
                  <p className="support-info">
                    <span className="service-icon">📧</span>
                    {t('hero.product.emailViberSupport', 'Email & Viber поддршка за креирање профил')}
                  </p>
                </div>
                
                <Link to={`/${currentLang}/products`} className="product-order-btn">
                  <span className="btn-shine"></span>
                  {t('hero.product.orderButton', 'Премиум Квалитет')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
